import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import Home from './pages/Home';
import Blog from './pages/Blog';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import CookiePolicy from './pages/CookiePolicy';
import TeeTimes from './pages/TeeTimes';
import TeeSheetDemo from './pages/TeeSheetDemo';
import TextMessaging from './pages/TextMessaging';

function App() {
  const { pathname } = useLocation();
  const textMessagingPage = pathname === '/text-messaging';

  return (
    <div className={textMessagingPage ? 'min-h-screen' : 'flex flex-col min-h-screen'}>
      <Header />
      <main className={textMessagingPage ? '' : 'flex-grow'}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/teetimes" element={<TeeTimes />} />
          <Route path="/tee-sheet-demo" element={<TeeSheetDemo />} />
          <Route path="/text-messaging" element={<TextMessaging />} />
        </Routes>
      </main>
      {!textMessagingPage && <Footer />}
      {!textMessagingPage && <CookieConsent />}
    </div>
  );
}

export default App; 